import { createGlobalStyle } from "styled-components";


import InterBold from "../assets/fonts/Inter-Bold.ttf";
import InterRegular from "../assets/fonts/Inter-Regular.ttf";
import InterMedium from "../assets/fonts/Inter-Medium.ttf";



import { theme } from "../helpers/theme";




export const GlobalStyle = createGlobalStyle`



@font-face {
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  src: url(${InterBold});
}

@font-face {
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 500;
  src: url(${InterMedium});
}

@font-face {
  font-family: ${theme.fonts.interMedium};
  font-style: normal;
  font-weight: 400;
  src: url(${InterRegular});
}



html {
  font-family: $font-family-primary, sans-serif;
  //font-size: 62.5%;
  height: 100%;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //font-size: 1.6rem;
  height: 100%;
  margin: 0;
  min-height: 100%;
  background-color:${theme.colors.gray04_background};
 
}

html,
body {
  text-size-adjust: none;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
}

*,
*:before,
*:after {
  //box-sizing: border-box;
 // width: 100%;//test
}`;



